import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black bg-opacity-90 backdrop-blur-sm border-b border-white border-opacity-10">
      <div className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-white text-2xl font-light tracking-wider hover:opacity-70 transition-opacity font-oswald">
            DOMINIQUE FIORE
          </Link>
          <div className="flex gap-8">
            <Link 
              to="/" 
              className={`text-sm tracking-widest transition-all font-oswald ${
                isActive('/') 
                  ? 'text-white font-bold' 
                  : 'text-gray-400 hover:text-white font-light'
              }`}
              data-testid="nav-home"
            >
              HOME
            </Link>
            <Link 
              to="/projects" 
              className={`text-sm tracking-widest transition-all font-oswald ${
                isActive('/projects') 
                  ? 'text-white font-bold' 
                  : 'text-gray-400 hover:text-white font-light'
              }`}
              data-testid="nav-projects"
            >
              PROJECTS
            </Link>
            <Link 
              to="/cv" 
              className={`text-sm tracking-widest transition-all font-oswald ${
                isActive('/cv') 
                  ? 'text-white font-bold' 
                  : 'text-gray-400 hover:text-white font-light'
              }`}
              data-testid="nav-cv"
            >
              CV
            </Link>
            <Link 
              to="/contact" 
              className={`text-sm tracking-widest transition-all font-oswald ${
                isActive('/contact') 
                  ? 'text-white font-bold' 
                  : 'text-gray-400 hover:text-white font-light'
              }`}
              data-testid="nav-contact"
            >
              CONTACT
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
